// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a10015e1","157":"5fbeb651","408":"02eca6ec","437":"dc1d07fc","460":"c6e1c7a3","532":"e96412ad","639":"19665500","659":"2c9c85a0","700":"473a93e4","749":"fd2a43f3","840":"08133aea","874":"ac3cde17"}[chunkId] + ".chunk.js";
};